import axios from 'axios';
import { API_URL } from '../config';

export default class {

    static getAll = async (token) => {
        let result = {
            data: null,
            error: null
        };

        await axios.get(`${API_URL}/invoices/admin/all`,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : err.message;
            });

        return result;
    }

    static delete = async (token, id) => {
        let result = {
            data: null,
            error: null
        };

        await axios.delete(`${API_URL}/invoices/admin/${id}`,
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : err.message;
            });

        return result;
    }

    static updateStatus = async (token, id, status) => {
        let result = {
            data: null,
            error: null
        };

        await axios.put(`${API_URL}/invoices/admin/${id}/status`, { status },
            { headers: { 'alshorja_auth': token } })
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : err.message;
            });

        return result;
    }

    static getById = async (token, id) => {
        let result = {
            data: null,
            error: null
        };

        await axios.get(`${API_URL}/invoices/${id}`,
            { headers: { 'alshorja_auth': token } }) // Using standard get endpoint, assuming admin can access
            .then(resp => {
                if (resp.status === 200) {
                    result.data = resp.data;
                }
            })
            .catch(err => {
                result.error = err.response ? err.response.data : err.message;
            });

        return result;
    }
}
